import { render, staticRenderFns } from "./SubscriptionBenefitDetails.vue?vue&type=template&id=5b919e82&scoped=true&"
import script from "./SubscriptionBenefitDetails.vue?vue&type=script&lang=js&"
export * from "./SubscriptionBenefitDetails.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionBenefitDetails.vue?vue&type=style&index=0&id=5b919e82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b919e82",
  null
  
)

export default component.exports